/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React from "react";
import { useTranslation } from "react-i18next";
import Row from "../core/Row";
import Col from "../core/Col";

const PageNotFound = () => {
  const { t } = useTranslation(["common"]);

  return (
    <Row>
      <Col xs="12" className="text-center">
        <Row>
          <Col xs="12" className="text-center">
            {t("common:page_not_found")}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PageNotFound;
